export default "__VITE_ASSET__CoC2C$Ng__"